import styled from 'styled-components';

export const Container = styled.div`
  height: 100%;
`;

export const Splash = styled.div`
  height: 100%;
  background-color: ${props => props.theme.primaryDark};
`;
